{
  "agentInformationVisible": true,
  "company": {
    "businessHours": {
      "saturday": true,
      "sunday": false,
      "weekdayEnd": "friday",
      "weekdayStart": "monday",
      "weekdaysHours": "09:00-21:00",
      "weekendsHours": "11:00-15:00"
    },
    "icon": "prosperty",
    "name": "Prosperty",
    "phone": {
      "code": "+30",
      "number": "+30 210 68 12 500"
    }
  },
  "newListingThresholdDays": 7,
  "squareMeterPriceVisible": true,
  "vatablePriceVisible": false
}
